// AgentDashboard.jsx - Updated Aadhar Pay service with redirect on active status

import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Modal, Button, Space, Checkbox, Radio, message as antMessage, Modal as AntModal } from 'antd';
import { InfoCircleOutlined, CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import CommingSoon from '../../container/commingsoon';
import { postRequest, getRequest } from '../../Utils/AppApi';
import { POST_SEND_MATM_OFFER_API } from '../../Utils/appConstants';
import { toast } from 'react-toastify';
import finoLogo from '../../assets/fino_logo.png';
import airteLogo from '../../assets/airtel_icon.png';

import UnderMaintance from '../../container/underMaintance';
import axios from 'axios';
import { API_URL } from '../../config';

// API Endpoints
const CHECK_AADHAR_PAY_STATUS = '/adharPay/check-status';
const REGISTER_AADHAR_PAY = '/adharPay/create-request';

function AgentDashboard(props) {
  const history = useHistory();
  const [isMatchCheckbox, setMatchCheckbox] = useState(false);
  const [ecollect, setEcollect] = useState(false);
  const [commingSoon, setCommingSoon] = useState(false);
  const [underMaintenance, setUnderMaintenance] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState('Under Maintenance');
  const [userProfile, setUserProfile] = useState(null);
  const [showService, setShowService] = useState(false);
  const [isMatmModal, setMatmModal] = useState(false);
  const [isProductName, setProductName] = useState("Combo");
  const [isProductAmount, setProductAmount] = useState("4200");
  const [appInfo, setAppInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [infoModal, setInfoModal] = useState({ visible: false, title: '', message: '' });

  // Aadhar Pay Registration State
  const [aadharPayModal, setAadharPayModal] = useState({ visible: false, step: 'status', data: null, loading: false });
  const [registrationModal, setRegistrationModal] = useState({ visible: false, loading: false });

  const serviceOption = [
    { value: 'Combo', label: 'Combo', amount: '4200' },
    { value: 'Mantra L1', label: 'Mantra L1', amount: '3200' },
    { value: 'MATM (Morefun MP63)', label: 'MATM (Morefun MP63)', amount: '1800' }
  ];

  // Function to show info popup for disabled features
  const showInfoPopup = (title, message) => {
    setInfoModal({
      visible: true,
      title: title,
      message: message
    });
  };

  // Function to check if a feature is enabled and show info popup if disabled
  const isFeatureEnabled = (featureName, featureFlag, customMessage = null) => {
    if (!featureFlag) {
      const messageText = customMessage || `${featureName} service is currently disabled. Please contact support for more information.`;
      showInfoPopup(featureName + ' - Service Unavailable', messageText);
      return false;
    }
    return true;
  };

  // ====================== AADHAR PAY FUNCTIONS ======================

  // Check Aadhar Pay registration status
  const checkAadharPayStatus = async () => {
    setAadharPayModal(prev => ({ ...prev, loading: true }));

    try {
      const response = await getRequest(CHECK_AADHAR_PAY_STATUS, history);

      if (response.success) {
        const data = response.data;
        const status = data.status;

        // If already active, directly go to Aadhar Pay page
        if (status === 'active') {
          antMessage.success('Aadhar Pay is active. Redirecting...');
          history.push('/aadhar-pay');
          setAadharPayModal(prev => ({ ...prev, visible: false, loading: false }));
          return;
        }

        // If approved but not active yet, show message and redirect after confirmation
        if (status === 'approved') {
          antMessage.info('Your Aadhar Pay registration has been approved. Service will be activated shortly.');
          setAadharPayModal(prev => ({ ...prev, visible: false, loading: false }));
          return;
        }

        // For other statuses, show the modal
        setAadharPayModal({
          visible: true,
          step: 'status',
          data: data,
          loading: false
        });
      } else {
        antMessage.error(response.message || 'Failed to check status');
        setAadharPayModal(prev => ({ ...prev, loading: false, visible: false }));
      }
    } catch (error) {
      console.error('Error checking Aadhar Pay status:', error);
      antMessage.error('Failed to check Aadhar Pay status');
      setAadharPayModal(prev => ({ ...prev, loading: false, visible: false }));
    }
  };

  // Register for Aadhar Pay
  const registerForAadharPay = async () => {
    setRegistrationModal(prev => ({ ...prev, loading: true }));

    try {
      const response = await postRequest(REGISTER_AADHAR_PAY, {}, history);

      if (response.success) {
        antMessage.success(response.message);
        setRegistrationModal({ visible: false, loading: false });
        setAadharPayModal(prev => ({ ...prev, visible: false }));
      } else {
        antMessage.error(response.message || 'Registration failed');
        setRegistrationModal(prev => ({ ...prev, loading: false }));
      }
    } catch (error) {
      console.error('Error registering for Aadhar Pay:', error);
      antMessage.error('Failed to register for Aadhar Pay');
      setRegistrationModal(prev => ({ ...prev, loading: false }));
    }
  };

  // Show registration confirmation
  const showRegistrationConfirmation = () => {
    setRegistrationModal({
      visible: true,
      loading: false
    });
  };

  // Handle Aadhar Pay button click
  const handleAadharPayClick = () => {
    if (!isFeatureEnabled('Aadhaar Pay', appInfo?.aadhaarPayEnabled)) {
      return;
    }

    // history.push('/aadhar-pay');
    checkAadharPayStatus();
  };

  // Render Aadhar Pay Status Modal
  // Render Aadhar Pay Status Modal
  const renderAadharPayStatusModal = () => {
    const { data, loading } = aadharPayModal;

    if (!data) return null;

    const { status, requestDetails } = data;

    // Status configurations
    const statusConfig = {
      active: {
        icon: <CheckCircleOutlined style={{ fontSize: 64, color: '#52c41a' }} />,
        title: 'Aadhar Pay Active',
        message: 'Your Aadhar Pay service is active and ready to use.',
        button: () => history.push('/aadhar-pay'),
        buttonText: 'Go to Aadhar Pay'
      },
      approved: {
        icon: <CheckCircleOutlined style={{ fontSize: 64, color: '#1890ff' }} />,
        title: 'Request Approved',
        message: 'Your Aadhar Pay registration has been approved. Service will be activated shortly.',
        button: null,
        buttonText: ''
      },
      in_process: {
        icon: <ClockCircleOutlined style={{ fontSize: 64, color: '#faad14' }} />,
        title: 'Request In Process',
        message: 'Your Aadhar Pay registration request is under process. Please wait for bank approval.',
        button: null,
        buttonText: ''
      },
      pending: {
        icon: <ClockCircleOutlined style={{ fontSize: 64, color: '#faad14' }} />,
        title: 'Request Pending',
        message: 'Your Aadhar Pay registration request is pending. SRPAY Support team will contact you soon.',
        button: null,
        buttonText: ''
      },
      rejected: {
        icon: <CloseCircleOutlined style={{ fontSize: 64, color: '#ff4d4f' }} />,
        title: 'Registration Rejected',
        message: `Your Aadhar Pay registration request was rejected.\n\nReason: ${requestDetails?.rejectionReason || 'Not specified'}`,
        button: () => showRegistrationConfirmation(),
        buttonText: 'Register Again'
      },
      not_registered: {
        icon: <InfoCircleOutlined style={{ fontSize: 64, color: '#1890ff' }} />,
        title: 'Register for Aadhar Pay',
        message: 'Registration Fee: ₹50 (One-time fee)\n\nEnjoy seamless Aadhar Pay transactions after registration.\n\nNote: Registration fee will be deducted from your wallet upon confirmation.',
        button: () => showRegistrationConfirmation(),
        buttonText: 'Register Now'
      }
    };

    const config = statusConfig[status] || statusConfig.not_registered;

    return (
      <AntModal
        title="Aadhar Pay Service"
        open={aadharPayModal.visible}
        onCancel={() => setAadharPayModal(prev => ({ ...prev, visible: false }))}
        footer={[
          <Button key="close" onClick={() => setAadharPayModal(prev => ({ ...prev, visible: false }))}>
            Close
          </Button>,
          config.button && (
            <Button
              key="action"
              type="primary"
              onClick={config.button}
              style={{ backgroundColor: status === 'rejected' ? '#ff4d4f' : '#52c41a' }}
            >
              {config.buttonText}
            </Button>
          )
        ]}
        width={500}
        centered
      >
        <div style={{ textAlign: 'center', padding: '20px' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div style={{
                width: '40px',
                height: '40px',
                border: '3px solid #f3f3f3',
                borderTop: '3px solid #10b981',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 16px'
              }} />
              <p>Checking status...</p>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: '20px' }}>
                {config.icon}
              </div>
              <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: '#1e293b' }}>
                {config.title}
              </h3>
              <p style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.6', whiteSpace: 'pre-line' }}>
                {config.message}
              </p>
              {status !== 'not_registered' && status !== 'active' && requestDetails?.requestId && (
                <div style={{
                  marginTop: '16px',
                  padding: '12px',
                  backgroundColor: '#f0f5ff',
                  borderRadius: '8px',
                  border: '1px solid #adc6ff'
                }}>
                  <span style={{ fontSize: '12px', color: '#666' }}>Request ID: <strong>{requestDetails.requestId}</strong></span>
                </div>
              )}
              {status === 'rejected' && (
                <div style={{
                  marginTop: '16px',
                  padding: '12px',
                  backgroundColor: '#fff2f0',
                  borderRadius: '8px',
                  border: '1px solid #ffccc7'
                }}>
                  <span style={{ fontSize: '12px', color: '#ff4d4f' }}>
                    You can register again by clicking the "Register Again" button.
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      </AntModal>
    );
  };
  // Render Registration Confirmation Modal
  const renderRegistrationConfirmationModal = () => {
    return (
      <AntModal
        title="Confirm Registration"
        open={registrationModal.visible}
        onCancel={() => setRegistrationModal({ visible: false, loading: false })}
        footer={[
          <Button key="cancel" onClick={() => setRegistrationModal({ visible: false, loading: false })}>
            Cancel
          </Button>,
          <Button
            key="confirm"
            type="primary"
            loading={registrationModal.loading}
            onClick={registerForAadharPay}
            style={{ backgroundColor: '#52c41a' }}
          >
            Confirm Registration
          </Button>
        ]}
        width={450}
        centered
      >
        <div style={{ padding: '10px' }}>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <InfoCircleOutlined style={{ fontSize: 48, color: '#faad14' }} />
          </div>
          <p style={{ fontSize: '16px', marginBottom: '16px', textAlign: 'center' }}>
            Are you sure you want to register for Aadhar Pay?
          </p>
          <div style={{
            backgroundColor: '#f8fafc',
            padding: '16px',
            borderRadius: '8px',
            marginBottom: '16px'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
              <span>Registration Fee:</span>
              <strong>₹50</strong>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>Note:</span>
              <strong style={{ color: '#faad14' }}>One-time fee</strong>
            </div>
          </div>
          <p style={{ fontSize: '12px', color: '#666', textAlign: 'center' }}>
            Registration fee of ₹50 will be deducted from your wallet upon confirmation.
          </p>
        </div>
      </AntModal>
    );
  };

  // Services data - ALL menus are visible
  const services = [
    {
      id: 'upi-atm',
      title: 'UPI Cash Point',
      icon: '../images/upi_qr_atm.png',
      show: true,
      featureFlag: appInfo?.scanPayEnabled,
      featureName: 'Scan & Pay',
      defaultValue: true,
      onClick: () => {
        const isEnabled = appInfo?.scanPayEnabled !== undefined ? appInfo.scanPayEnabled : true;
        if (isFeatureEnabled('UPI Cash Point', isEnabled)) {
          history.push({ pathname: "/upi-atm" })
        }
      }
    },
    {
      id: 'money-transfer',
      title: 'Money Transfer',
      icon: '../images/express-dmt.png',
      show: showService,
      requiresKyc: true,
      onClick: () => history.push({ pathname: "/money-transfer" })
    },
    {
      id: 'aeps',
      title: 'AEPS',
      subtitle: 'Powered By NSDL',
      icon: '../images/aeps-icon.png',
      show: showService,
      requiresKyc: true,
      onClick: () => history.push({ pathname: "/aeps" })
    },
    {
      id: 'express-aeps',
      title: 'Express AEPS',
      subtitle: 'Powered By YBL / APB',
      icon: '../images/aeps-icon.png',
      show: showService,
      requiresKyc: true,
      onClick: () => {
        const yblKyc = userProfile?.userDetails.instantPayBioEkyc || false;
        if (yblKyc) {
          history.push({ pathname: "/express-aeps" })
        } else {
          history.push({ pathname: "/partner-ekyc" });
        }
      }
    },
    {
      id: 'cash-deposit',
      title: 'Cash Deposit',
      icon: '../images/cash-deposit.png',
      show: true,
      featureFlag: appInfo?.cashDepositEnabled,
      featureName: 'Cash Deposit',
      onClick: () => {
        if (isFeatureEnabled('Cash Deposit', appInfo?.cashDepositEnabled)) {
          history.push({ pathname: "/cash-deposit" })
        }
      }
    },
    {
      id: 'upi-atm-2',
      title: 'UPI Cash Withdrawal',
      icon: '../images/upi_qr_atm.png',
      show: true,
      featureFlag: appInfo?.fpQRAtmEnabled,
      featureName: 'UPI Cash Withdrawal',
      subtitle: 'Powered By Kotak Mahindra Bank',
      defaultValue: true,
      onClick: () => {
        const isEnabled = appInfo?.fpQRAtmEnabled !== undefined ? appInfo.fpQRAtmEnabled : true;
        if (isFeatureEnabled('UPI Cash Withdrawal', isEnabled)) {
          history.push({ pathname: "/upi-atm2" })
        }
      }
    },
    {
      id: 'express-dmt',
      title: 'Airtel DMT',
      icon: airteLogo,
      subtitle: 'Powered By Airtel Payment Bank',
      show: showService,
      requiresKyc: true,
      onClick: () => history.push({ pathname: "/money-transfer-express" })
    },




    {
      id: 'utility-offline',
      title: ' LIC & Bill PAY',
      icon: '../images/utilityicon-1@2x.png',
      show: true,
      featureFlag: appInfo?.utilityOfflineEnabled,
      featureName: 'LIC & Bill PAY',
      defaultValue: true,
      onClick: () => {
        const isEnabled = appInfo?.utilityOfflineEnabled !== undefined ? appInfo.utilityOfflineEnabled : true;
        if (isFeatureEnabled('Utility Payment Offline', isEnabled)) {
          history.push({ pathname: "/uitility-payment-offline" })
        }
      }
    },
    {
      id: 'bill-pay2',
      title: 'BBPS',
      icon: '../bbps/b_mnemonic.png',
      show: true,
      featureFlag: appInfo?.bbpsImWalletEnabled,
      featureName: 'BBPS',
      onClick: () => {
        history.push({ pathname: "/bbps-payment" })
      }
    },

    {
      id: 'fund-settlement',
      title: 'Fund Settlement',
      icon: '../images/deposit-money-bank.png',
      show: true,
      featureFlag: appInfo?.payoutEnabled,
      featureName: 'Fund Settlement',
      onClick: () => {
        if (isFeatureEnabled('Fund Settlement', appInfo?.payoutEnabled)) {
          history.push({ pathname: "/move-to-bank" });
        }
      }
    },




    {
      id: 'mobile-dth',
      title: 'Mobile / DTH',
      icon: '../images/mobile-dth-1@2x.png',
      show: true,
      onClick: () => history.push({ pathname: "/mobile-recharge" })
    },
    {
      id: 'utility-2',
      title: 'Electricity Bill Pay',
      icon: '../images/utilityicon-1@2x.png',
      show: true,
      onClick: () => history.push({ pathname: "/uitility-payment-2-0" })
    },
    {
      id: 'fastag',
      title: 'FASTAG',
      icon: '../images/fastag-logo-icon.svg',
      show: true,
      featureFlag: appInfo?.fastagEnabled,
      featureName: 'FASTAG',
      defaultValue: true,
      onClick: () => {
        const isEnabled = appInfo?.fastagEnabled !== undefined ? appInfo.fastagEnabled : true;
        if (isFeatureEnabled('FASTAG', isEnabled)) {
          history.push({ pathname: "/fastag-payment" })
        }
      }
    },
    {
      id: 'lic-premium',
      title: 'LIC Premium',
      icon: '../images/lic_dash.png',
      show: true,
      featureFlag: appInfo?.licPremiumEnabled,
      featureName: 'LIC Premium',
      defaultValue: true,
      onClick: () => {
        const isEnabled = appInfo?.licPremiumEnabled !== undefined ? appInfo.licPremiumEnabled : true;
        if (isFeatureEnabled('LIC Premium', isEnabled)) {
          history.push({ pathname: "/insurance-payment" })
        }
      }
    },

    //    {
    //   id: 'fino-dmt',
    //   title: 'FINO Suvidha DMT',
    //   icon: finoLogo,
    //   show: true,
    //   featureFlag: appInfo?.finoSuvidhaEnabled,
    //   featureName: 'FINO Suvidha DMT',
    //   onClick: () => {
    //     if (isFeatureEnabled('FINO Suvidha DMT', appInfo?.finoSuvidhaEnabled)) {
    //       const finoEnabled = String(userProfile?.finoIsEnabled || '').toLowerCase();
    //       const fino = String(userProfile?.finoUsers || '').toLowerCase();
    //       if (fino === "true") {
    //         if (finoEnabled !== "true") {
    //           showInfoPopup('Access Denied', "You are not allowed to Use FINO DMT, Please contact your Distributor or SRPAY Support team.");
    //           return;
    //         } else {
    //           history.push({ pathname: "/fino" });
    //         }
    //       } else {
    //         history.push({ pathname: "/partner-ekyc" });
    //       }
    //     }
    //   }
    // },

    {
      id: 'matm-offer',
      title: 'MATM Combo Offer',
      subtitle: 'Purchase New Device',
      icon: '../images/matm.png',
      special: true,
      show: true,
      onClick: () => handleMatmModal()
    },
    {
      id: 'partner-kyc',
      title: 'Partner KYC',
      icon: '../images/kyc-icon.png',
      show: true,
      onClick: () => history.push({ pathname: "/partner-ekyc" })
    },
    {
      id: 'instant-topup',
      title: 'Instant Topup',
      icon: '../images/instanttopup-1@2x.png',
      show: true,
      onClick: () => comm()
    },

    {
      id: 'aadhar-pay',
      title: 'Aadhar Pay',
      icon: '../images/aadharpay-1@2x.png',
      show: true,
      featureFlag: appInfo?.aadhaarPayEnabled,
      featureName: 'Aadhaar Pay',
      onClick: handleAadharPayClick
    },
    {
      id: 'card-payment',
      title: 'Credit Card Payment',
      icon: '../images/card-1@2x.png',
      show: true,
      featureFlag: appInfo?.creditCardEnabled,
      featureName: 'Credit Card Payment',
      defaultValue: true,
      onClick: () => {
        const isEnabled = appInfo?.creditCardEnabled !== undefined ? appInfo.creditCardEnabled : true;
        if (isFeatureEnabled('Credit Card Payment', isEnabled)) {
          history.push({ pathname: "/credit-card-bill" })
        }
      }
    },
    {
      id: 'nepal-remittance',
      title: 'Nepal Remittance',
      icon: '../images/money-icon.png',
      show: true,
      onClick: () => comm()
    },

  ];

  const fetchAppInfo = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_URL + `/appinfo`);
      setAppInfo(response.data);
    } catch (err) {
      console.error("Failed to fetch app info", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppInfo();
  }, []);

  const handleOpenECollectClose = () => setEcollect(false);
  const comm = () => setCommingSoon(true);
  const handleOpenClose = () => setCommingSoon(false);
  const handleUnderMaintClose = () => setUnderMaintenance(false);

  const underMaint = (msg = 'Under Maintenance') => {
    setMaintenanceMessage(msg);
    setUnderMaintenance(true);
  };

  const handleMatmModal = () => setMatmModal(true);
  const onChangeChackBox = (e) => setMatchCheckbox(e.target.checked);

  const handleSizeChange = ({ target: { value } }) => {
    let data = serviceOption.filter((items) => items.value === value);
    setProductName(value);
    setProductAmount(data[0].amount);
  };

  const sendBuyOffer = () => {
    let payload = {
      quantity: 1,
      amount: isProductAmount,
      product: isProductName,
      comment: ""
    }
    postRequest(POST_SEND_MATM_OFFER_API, payload, history).then((response) => {
      if (response.success === true) {
        setMatchCheckbox(false);
        setMatmModal(false);
        toast.success(response.message);
      } else {
        setMatmModal(false);
        toast.error(response.message);
      }
    }).catch(function (error) {
      setMatmModal(false);
      console.log(error);
    })
  }

  useEffect(() => {
    if (props.userData || !userProfile) {
      setUserProfile(props.userData.data)
    }
    if (userProfile && userProfile.kycStatus === 3) {
      setShowService(true)
    }
  }, [userProfile]);

  // Filter services based on show condition (only KYC-based visibility)
  const filteredServices = services.filter(service => service.show !== false);

  return (
    <div style={{
      background: '#f8fafc',
      minHeight: '100vh',
      padding: '24px'
    }}>
      {/* Services Grid - 5 cards per row */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '24px',
        maxWidth: '1600px',
        margin: '0 auto'
      }}>
        {filteredServices.map((service) => {
          return (
            <div
              key={service.id}
              className="service-card"
              style={{
                background: 'linear-gradient(135deg, rgba(134, 239, 172, 0.1) 0%, rgba(251, 191, 36, 0.1) 100%)',
                borderRadius: '14px',
                padding: '20px',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                minHeight: '120px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
                e.currentTarget.style.boxShadow = '0 20px 60px rgba(0, 0, 0, 0.15)';
                e.currentTarget.style.background = 'linear-gradient(135deg, rgba(134, 239, 172, 0.15) 0%, rgba(251, 191, 36, 0.15) 100%)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                e.currentTarget.style.background = 'linear-gradient(135deg, rgba(134, 239, 172, 0.1) 0%, rgba(251, 191, 36, 0.1) 100%)';
              }}
              onClick={() => {
                service.onClick();
              }}
            >
              {/* Special badge for MATM only */}
              {service.special && (
                <div style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  background: 'linear-gradient(135deg, #10b981 0%, #f59e0b 100%)',
                  color: 'white',
                  fontSize: '0.7rem',
                  padding: '4px 10px',
                  borderRadius: '12px',
                  fontWeight: '700',
                  letterSpacing: '0.5px',
                  boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
                  zIndex: 3,
                  border: '2px solid rgba(255, 255, 255, 0.6)',
                  textTransform: 'uppercase',
                  lineHeight: '1'
                }}>
                  Hot Offer
                </div>
              )}

              {/* Icon Container - Left Side */}
              <div style={{
                width: '48px',
                height: '48px',
                minWidth: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                borderRadius: '12px',
                padding: '10px',
                marginRight: '16px',
                boxShadow: '0 3px 6px rgba(0, 0, 0, 0.08), inset 0 1px 3px rgba(255, 255, 255, 0.8)',
                border: '1px solid rgba(203, 213, 225, 0.5)',
                position: 'relative',
                zIndex: 2
              }}>
                {typeof service.icon === 'string' ? (
                  <img
                    src={service.icon}
                    alt={service.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      filter: 'brightness(1.05) contrast(1.1)'
                    }}
                  />
                ) : (
                  <div style={{
                    fontSize: '1.5rem',
                    color: '#10b981',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {service.icon}
                  </div>
                )}
              </div>

              {/* Text Content - Right Side */}
              <div style={{
                flex: 1,
                textAlign: 'left',
                overflow: 'hidden',
                position: 'relative',
                zIndex: 2
              }}>
                <div style={{
                  fontSize: '0.95rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '6px',
                  lineHeight: '1.3',
                  letterSpacing: '-0.01em',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {service.title}
                </div>
                {service.subtitle && (
                  <div style={{
                    fontSize: '0.75rem',
                    color: '#64748b',
                    fontWeight: '500',
                    lineHeight: '1.3',
                    opacity: '0.9',
                    letterSpacing: '0.01em',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {service.subtitle}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Loading State */}
      {loading && (
        <div style={{
          textAlign: 'center',
          padding: '60px 20px',
          color: '#64748b',
          marginTop: '40px'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #10b981',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }} />
          <p style={{
            fontSize: '0.9rem',
            fontWeight: '500',
            letterSpacing: '0.3px'
          }}>
            Loading services...
          </p>
        </div>
      )}

      {/* Info Popup Modal for Disabled Services */}
      <AntModal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <InfoCircleOutlined style={{ color: '#faad14', fontSize: '20px' }} />
            <span>{infoModal.title}</span>
          </div>
        }
        open={infoModal.visible}
        onOk={() => setInfoModal({ visible: false, title: '', message: '' })}
        onCancel={() => setInfoModal({ visible: false, title: '', message: '' })}
        okText="Got It"
        cancelButtonProps={{ style: { display: 'none' } }}
        centered
      >
        <div style={{ padding: '8px 0' }}>
          <p style={{ fontSize: '14px', color: '#4a5568', margin: 0 }}>
            {infoModal.message}
          </p>
        </div>
      </AntModal>

      {/* Aadhar Pay Status Modal */}
      {renderAadharPayStatusModal()}

      {/* Aadhar Pay Registration Confirmation Modal */}
      {renderRegistrationConfirmationModal()}

      {/* CSS for gradient border */}
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .service-card {
          border-radius: 14px;
          padding: 10px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
        }
        .service-card::after {
          content: '';
          position: absolute;
          inset: 0;
          padding: 3px;
          background: linear-gradient(135deg, rgb(18, 176, 139), rgb(224, 88, 9));
          border-radius: 17px;
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          mask-composite: exclude;
          transition: all 0.3s ease;
          pointer-events: none;
        }
        .service-card:hover::after {
          background: linear-gradient(135deg, rgb(18, 176, 139), rgb(224, 88, 9));
        }
        @media (max-width: 1600px) { div[style*="gridTemplateColumns"] { grid-template-columns: repeat(5, 1fr) !important; } }
        @media (max-width: 1400px) { div[style*="gridTemplateColumns"] { grid-template-columns: repeat(4, 1fr) !important; } }
        @media (max-width: 1200px) { div[style*="gridTemplateColumns"] { grid-template-columns: repeat(3, 1fr) !important; } }
        @media (max-width: 992px) { div[style*="gridTemplateColumns"] { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 768px) {
          div[style*="gridTemplateColumns"] {
            grid-template-columns: 1fr !important;
            max-width: 400px;
            margin: 0 auto;
          }
        }
      `}</style>

      {/* Other Modals */}
      {ecollect && (
        <Modal
          open={ecollect}
          onCancel={() => handleOpenECollectClose()}
          footer={false}
          centered
        >
          <Space direction="vertical" style={{ width: '100%' }} className='mt-20'>
            <a target='_blank' rel="noreferrer" href='https://www.onlinesbi.sbi/sbicollect/icollecthome.htm?corpID=856614'>
              <Button type="primary" block>SBI Collect</Button>
            </a>
            <Button type="default" block>PNB Collect</Button>
            <Button type="default" block>UNION Collect</Button>
          </Space>
        </Modal>
      )}

      {commingSoon && (
        <Modal
          open={commingSoon}
          onCancel={() => handleOpenClose()}
          footer={false}
          width={"500px"}
          centered
        >
          <CommingSoon />
        </Modal>
      )}

      {underMaintenance && (
        <Modal
          open={underMaintenance}
          onCancel={() => handleUnderMaintClose()}
          footer={false}
          width={"500px"}
          centered
        >
          <UnderMaintance message={maintenanceMessage} />
        </Modal>
      )}

      {isMatmModal && (
        <Modal
          open={isMatmModal}
          onCancel={() => setMatmModal(false)}
          okText={"Confirm"}
          onOk={() => sendBuyOffer()}
          okButtonProps={{ disabled: !isMatchCheckbox }}
          width={500}
          centered
        >
          <div className="col-md-6 col-lg-12 mb-1">
            <img src='../../festival/offer.jpeg' width={"540"} alt='' style={{
              borderRadius: '8px',
              marginBottom: '20px'
            }} />
            <div className="row">
              <div className='col-md-12 form-group mt-3'>
                <Radio.Group
                  options={serviceOption}
                  value={isProductName}
                  buttonStyle="solid"
                  optionType="button"
                  onChange={handleSizeChange}
                  style={{ width: '100%', display: 'flex', gap: '10px' }}
                />
              </div>
            </div>
            <Checkbox className="mr-2" onChange={onChangeChackBox} />
            <p className="mt-2 text-primary pl-3">
              I hereby confirm that i accept the SRPAY MATM Combo offer worth Rs. {isProductAmount}.
            </p>
            <strong>
              Note :- <span className="text-danger">Once the Product is purchased amount is not refundable.</span>
            </strong>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default AgentDashboard;